import { gql } from "@apollo/client"

export const GET_SEDICII_VERIFICATIONS_BY_PERSON_ID = gql`
  query GetSediciiVerificationsByPersonId(
    $input: GetSediciiVerificationsByPersonIdInput!
  ) {
    getSediciiVerificationsByPersonId(input: $input) {
      id
      status
      createdAt
      lastUpdatedAt
      documents {
        id
        documentType
        fileName
        contentType
        downloadUrl
        uploadStatus
        createdAt
        lastUpdatedAt
      }
    }
  }
`
